function isIE()
{
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0) // If Internet Explorer, return version number
    {
       return true
    }


    return false;
}

// custom js
var school = {

	init: function() {

        school.controls();
        if (isIE()) {
            $('.navbar').addClass("ie")
        }


	},

    controls: function() {

        $('.navigation-toggle').click(function() {
            $(this).toggleClass("show-nav");
            $(".navigation").toggleClass("show-nav");
        });

        $('.banners').slick({
            arrows: false,
            dots: true
        });
        $('.gallery').slick({
            arrows: true,
            dots: true,
            prevArrow: '<button type="button" class="slick-prev"><img src="/images/left-arrow.svg"></button>',
            nextArrow: '<button type="button" class="slick-next"><img src="/images/right-arrow.svg"></button>'
        });

        $('.venues').find('a').mouseover(function() {
            var index = $(this).attr('data-index');
            var link = $(this).attr('href');

            $('.venue-background').removeClass("active");
            $('.venue-background').eq((index-1)).addClass("active");

            $('.venues').find("a").removeClass("active");
            $(this).addClass("active");

            $('.venue-details').attr("href", link);
        });

        $(window).scroll(function() {
            var scroll_top = $('body').scrollTop();
            if (scroll_top > 500) {
                $('.navbar').addClass("active");
            }

            if (scroll_top < 500) {
                $('.navbar').removeClass("active");
            }
        })

    }
}


$(document).ready(function() {

    school.init();
    // For some reason the AM forms email field can't use placeholders
    $('.form__row--amforms_email').each(function() {
        $(this).find(".form__label").hide();
        $(this).find(".form__field input").attr("placeholder",$(this).find(".form__label label").text().trim());
    });

    $('.checkbox').click(function() {
        $(this).parent().find('label').toggleClass("label-underline");
    });

    if ($('label[for*="fields-checkbox"]:last').html() == "I have read and agree to the terms and conditions outlined in the Venue Hire Agreement Policy") {
        $('label[for*="fields-checkbox"]:last').html('I Have Read And Agree To The Terms and Conditions Outlined In The <a target="_blank" class="venue-hire-pdf" href="http://s3-ap-southeast-2.amazonaws.com/digistorm-websites/sh-au-qld-18-venue-hire/Documents/Venue-Hire-Agreement-Policy.pdf?mtime=20160824103451">Venue hire Agreement Policy (PDF)</a>');
    }

    $('input[type=radio][name*=hireTimeframe]').change(function() {
        if (this.value == 'Half Day Hire') {
            $('.form--venueHireApplicationForm .form__timeslot').css('display','inline-block');
            $('.form--venueHireApplicationForm .form__timeOfHire').css('display','none');
        }
        else if (this.value == 'Full Day Hire') {
            $('.form--venueHireApplicationForm .form__timeslot').css('display','none');
            $('.form--venueHireApplicationForm .form__timeOfHire').css('display','inline-block');
        }
    });
});
